import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { Icon } from '@zapier/zinnia-icons';
import { Input } from '../Input/Input.es.js';
import { DateRangePickerValue } from './DateRangePickerValue.es.js';

const root = "_root_95ynr_1";
const button = "_button_95ynr_8";
const clearSelectionButton = "_clear-selection-button_95ynr_17";
const placeholder = "_placeholder_95ynr_34";
const styles = {
	root: root,
	button: button,
	clearSelectionButton: clearSelectionButton,
	placeholder: placeholder
};

const ClearSelectionButton = ({ clearSelection }) => {
  return jsx("button", { type: "button", className: styles.clearSelectionButton, onClick: clearSelection, title: "Clear Selection", "data-zds": true, children: jsx(Icon, { canAcceptPointerEvents: false, name: "formXCircle", size: 20 }) });
};
const DateRangePickerInput = (props) => {
  const { value, clearSelection, size } = props;
  const { from, to } = value;
  const hasValue = Boolean(from || to);
  const showClearSelectionButton = hasValue && !props.isDisabled;
  return jsx("div", { className: styles.root, "data-disabled": props.isDisabled ? "true" : void 0, "data-zds": true, children: jsx(Input, { id: props.id, isDisabled: props.isDisabled, isErrored: props.isErrored, renderIconAfter: ({ iconSize, isFocused, isHovered }) => {
    if (props.renderIconAfter) {
      return props.renderIconAfter({
        iconSize,
        isFocused,
        isHovered,
        hasValue,
        isDisabled: props.isDisabled,
        clearSelection
      });
    }
    return showClearSelectionButton ? jsx(ClearSelectionButton, { clearSelection, isFocused, isHovered }) : null;
  }, renderIconBefore: ({ iconSize, isFocused, isHovered }) => {
    if (props.renderIconBefore) {
      return props.renderIconBefore({
        iconSize,
        isFocused,
        isHovered,
        hasValue,
        clearSelection,
        isDisabled: props.isDisabled
      });
    }
    return jsx(Icon, { name: "actionCalendar", size: iconSize });
  }, size, children: (inputProps) => (
    // Intentionally `button` and not `Button` since it looks
    // and behaves differently.
    // eslint-disable-next-line jsx-a11y/role-supports-aria-props
    jsx("button", { "aria-controls": inputProps["aria-controls"], "aria-expanded": props.isOpen ? "true" : "false", "aria-haspopup": "true", "aria-invalid": inputProps["aria-invalid"], "aria-label": inputProps["aria-label"], "data-size": size, className: clsx(styles.button, inputProps.className), disabled: inputProps.disabled, id: inputProps.id, onClick: props.onClick, onKeyDown: inputProps.onKeyDown, type: "button", "data-zds": true, children: hasValue ? jsx(DateRangePickerValue, { options: props.options, value: props.value }) : jsx("span", { className: styles.placeholder, "data-zds": true, children: props.placeholder }) })
  ) }) });
};

export { DateRangePickerInput };
//# sourceMappingURL=DateRangePickerInput.es.js.map
